import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { reactive, ref } from 'vue'
import { Form } from 'ant-design-vue'
import { message as DcMessage } from '@dc-platform/dc-components'
import { salesClueAllot } from '@/api/overseasSales/clueManage'
import type { SalesClueListItem } from '@/typings/api/clueManage'
import { useI18n } from 'vue-i18n'

const __default__ = { name: 'ClueAssign' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ['fetch'],
  setup(__props, { expose: __expose, emit: __emit }) {

const { t } = useI18n()
const useForm = Form.useForm
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const selectedData = ref<SalesClueListItem[]>([])
const dataForm = reactive<{ follower: string; clueIdList: any[] }>({ follower: '', clueIdList: [] })
const formRules = reactive({
  follower: [{ required: true, message: t('clue.selectSellor') }]
})
const { resetFields, validate, validateInfos } = useForm(dataForm, formRules)

const init = (data: SalesClueListItem[]) => {
  selectedData.value = data
  visible.value = true
}

const emit = __emit
const handleOk = () => {
  validate().then(() => {
    loading.value = true
    dataForm.clueIdList = selectedData.value.map((item: SalesClueListItem) => item.clueId)
    const params = Object.assign({}, dataForm)
    salesClueAllot(params)
      .then(() => {
        emit('fetch', dataForm.follower)
        DcMessage.success(t('tips.assignedSuccees'))
        resetFields()
        visible.value = false
      })
      .finally(() => {
        loading.value = false
      })
  })
}
const handleCancel = () => {
  resetFields()
}

__expose({ init })

return (_ctx: any,_cache: any) => {
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: visible.value,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
    title: _unref(t)('clue.asignOwner'),
    "body-style": { padding: '30px' },
    "confirm-loading": loading.value,
    onOk: handleOk,
    okText: _unref(t)('btn.confirm'),
    onCancel: handleCancel
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form, { "wrapper-col": { span: 24 } }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, _mergeProps({
            label: _unref(t)('clue.followerName')
          }, _unref(validateInfos).follower), {
            default: _withCtx(() => [
              _createVNode(_component_UserSelect, {
                value: dataForm.follower,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dataForm.follower) = $event)),
                status: 1,
                allowClear: ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 16, ["label"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["visible", "title", "confirm-loading", "okText"]))
}
}

})